import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Http, Response, URLSearchParams, Headers, RequestOptions } from '@angular/http';
import 'rxjs';

import { Config } from "../../../config";
import { Subject, BehaviorSubject } from "rxjs";
import { HttpService } from "./http.interceptor.service";



@Injectable()
export class EmailSmsSubject {
    public officeIdSubject: Subject<any> = new Subject();
    constructor() { }

    private notificationTypeChange = new Subject<any>();
    setNotificationTypeChange(officeId: any) {
        this.notificationTypeChange.next(officeId);
    }

    getNotificationTypeChange() {
        return this.notificationTypeChange.asObservable();
    }

    setOfficeId(id){
        this.officeIdSubject.next(id); 
        // localStorage.setItem("officeId", id);
    }

    /**
     * Subject to inform whether the add template is closed
     * USAGE: To refresh the content as soon as user closes the close button
     */
    private updatedata = new Subject<any>();
    updateData(officeId: any) {
        this.updatedata.next(officeId);
    }

    whenUpdateData() {
        return this.updatedata.asObservable();
    }

    private DeleteTemplate = new Subject<any>();
    setDeletedTemplateId(id){
        this.DeleteTemplate.next(id);
    }
    getDeletedTemplateId(){
        return this.DeleteTemplate.asObservable();
    }

     /**
     * Behaviour Subject when setting closes
     */
    public whenSettingCloses = new BehaviorSubject<any>(0);
 
    /**
     * Subject to call when the template is selected
     * USAGE: To fetch the templateBody as soon as user selects the template
     */
    private templateId = new Subject<any>();
    private templateId1 = new Subject<any>();
    setTemplateId(officeId: any) {
        this.templateId.next(officeId);
    }
    setTemplateId1(officeId: any) {
        this.templateId1.next(officeId);
    }

    getTemplateId() {
        return this.templateId.asObservable();
    }
    getTemplateId1() {
        return this.templateId1.asObservable();
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/email-sms-subject.ts